
if (!window.ncWarenkorbGeladen) {
  window.ncWarenkorbGeladen = true;

    (function () {
      if (window.ncEmpfehlungKachelBereit) return;
      window.ncEmpfehlungKachelBereit = true;

      document.addEventListener('click', function (e) {
        var knopf = e.target.closest ? e.target.closest('[data-nc-ek-knopf]') : null;
        if (!knopf) return;

        var kennung = knopf.getAttribute('data-nc-ek-id');
        if (!kennung) return;

        e.preventDefault();
        knopf.setAttribute('aria-busy', 'true');

        var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(wurzel + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: kennung,
              quantity: 1
            }]
          })
        }).then(function (r) {
          knopf.removeAttribute('aria-busy');
          if (!r.ok) { window.location.href = knopf.closest('.nc-ek').querySelector('a').href; return; }
          if (knopf) {
            var vorher = knopf.textContent;
            knopf.textContent = knopf.getAttribute('data-nc-ek-fertig') || vorher;
            setTimeout(function () { knopf.textContent = vorher; }, 2500);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }).catch(function () {
          knopf.removeAttribute('aria-busy');
          var ziel = knopf.closest('.nc-ek').querySelector('a');
          if (ziel) window.location.href = ziel.href;
        });
      });
    })();

    (function () {
      if (window.ncKaufEmpfBereit) return;
      window.ncKaufEmpfBereit = true;

      document.addEventListener('submit', function (e) {
        var form = e.target.closest ? e.target.closest('[data-nc-ke-form]') : null;
        if (!form) return;

        var idFeld = form.querySelector('[name="id"]');
        if (!idFeld || !idFeld.value) return;

        e.preventDefault();
        var knopf = form.querySelector('button');
        if (knopf) knopf.setAttribute('aria-busy', 'true');

        var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(wurzel + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: idFeld.value, quantity: 1 }] })
        }).then(function (r) {
          if (knopf) knopf.removeAttribute('aria-busy');
          if (!r.ok) { form.submit(); return; }
          /* D1368: Gutschein + Duft aus dem Popup ist ein Geschenkset. Die
             Set-Codes (Duft −10 %, Versand frei) loest das Theme selbst ein,
             niemand tippt einen Code. Schlaegt das fehl, liegt der Duft
             trotzdem im Warenkorb. */
          var codes = form.getAttribute('data-nc-ke-codes');
          if (codes) {
            fetch(wurzel + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: codes })
            }).then(function () {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }).catch(function () {});
          }
          if (knopf) {
            var vorher = knopf.textContent;
            var fertig = knopf.getAttribute('data-nc-ke-fertig');
            if (fertig) {
              knopf.textContent = fertig;
              knopf.disabled = true;
              knopf.classList.add('is-drin');
            }
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }).catch(function () {
          if (knopf) knopf.removeAttribute('aria-busy');
          form.submit();
        });
      });
    })();

  (function () {
    if (window.ncSchutzBereit) return;
    window.ncSchutzBereit = true;

    document.addEventListener('click', function (e) {
      var knopf = e.target && e.target.closest
        ? e.target.closest('[data-nc-sa-add], [data-nc-sa-weg]') : null;
      if (!knopf) return;
      if (knopf.disabled) return;

      var karte = knopf.closest ? knopf.closest('.nc-sa__zeile') : null;
      var block = knopf.closest ? knopf.closest('.nc-sa') : null;

      knopf.disabled = true;
      knopf.setAttribute('aria-busy', 'true');
      if (karte) karte.classList.add('nc-sa--laedt');

      var fertig = function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        knopf.disabled = false;
        knopf.removeAttribute('aria-busy');
        if (karte) karte.classList.remove('nc-sa--laedt');
      };

      var schief = function () {
        knopf.disabled = false;
        knopf.removeAttribute('aria-busy');
        if (!karte) return;
        karte.classList.remove('nc-sa--laedt');
        var alt = karte.querySelector('.nc-sa__fehler');
        if (alt) alt.remove();
        var text = block ? block.getAttribute('data-nc-sa-fehlertext') : '';
        if (!text) return;
        var p = document.createElement('p');
        p.className = 'nc-sa__fehler';
        p.setAttribute('role', 'status');
        p.textContent = text;
        karte.appendChild(p);
      };

      var pruefen = function (r) {
        if (r && r.ok === false) { schief(); return; }
        fertig();
      };

      if (knopf.hasAttribute('data-nc-sa-add')) {
        var kennung = parseInt(knopf.dataset.ncSaVariante, 10);
        if (!kennung) { schief(); return; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: kennung, quantity: 1 })
        }).then(pruefen).catch(schief);
      } else {
        var schluessel = knopf.dataset.ncSaKey || '';
        var zeilenNr = parseInt(knopf.dataset.ncSaLine || '0', 10);
        var last = null;
        if (schluessel) {
          last = { id: schluessel, quantity: 0 };
        } else if (zeilenNr > 0) {
          last = { line: zeilenNr, quantity: 0 };
        }
        if (!last) { schief(); return; }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(last)
        }).then(pruefen).catch(schief);
      }
    });

    document.addEventListener('change', function (e) {
      var wahl = e.target && e.target.closest ? e.target.closest('[data-nc-sa-laufzeit]') : null;
      if (!wahl) return;
      var karte = wahl.closest('.nc-sa__zeile');
      var knopf = karte ? karte.querySelector('[data-nc-sa-add]') : null;
      if (knopf) knopf.setAttribute('data-nc-sa-variante', wahl.value);
    });
  })();

  (function () {
    if (window.ncLieferangabenBereit) return;
    window.ncLieferangabenBereit = true;

    document.addEventListener('click', function (e) {
      var knopf = e.target.closest ? e.target.closest('[data-nc-la-knopf]') : null;
      if (!knopf) return;
      e.preventDefault();
      var id = knopf.getAttribute('aria-controls');
      var feld = id ? document.getElementById(id) : null;
      if (!feld) return;
      var offen = knopf.getAttribute('aria-expanded') === 'true';
      knopf.setAttribute('aria-expanded', offen ? 'false' : 'true');
      feld.hidden = offen;
      if (!offen) {
        var erstes = feld.querySelector('select, textarea');
        if (erstes) erstes.focus({ preventScroll: true });
      }
    });

    document.addEventListener('click', function (e) {
      var knopf = e.target.closest ? e.target.closest('[data-nc-la-sichern]') : null;
      if (!knopf) return;
      e.preventDefault();
      var feld = knopf.closest('[data-nc-la-feld]');
      if (!feld) return;

      var daten = { attributes: {} };
      var notiz = feld.querySelector('textarea[name="note"]');
      if (notiz) daten.note = notiz.value;
      var auswahlen = feld.querySelectorAll('select[name^="attributes["], input[name^="attributes["]');
      for (var i = 0; i < auswahlen.length; i++) {
        var n = auswahlen[i].getAttribute('name');
        var schluessel = n.substring(n.indexOf('[') + 1, n.lastIndexOf(']'));
        daten.attributes[schluessel] = auswahlen[i].value;
      }

      var alt = knopf.textContent;
      knopf.disabled = true;
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(daten)
      }).then(function (r) {
        knopf.disabled = false;
        knopf.textContent = r.ok ? (knopf.getAttribute('data-nc-la-gespeichert') || alt) : alt;
        if (r.ok) setTimeout(function () { knopf.textContent = alt; }, 2500);
      }).catch(function () {
        knopf.disabled = false;
        knopf.textContent = alt;
      });
    });
  })();

    (function () {
      if (window.ncPillsBereit) return;
      window.ncPillsBereit = true;

      document.addEventListener('click', function (e) {
        var k = e.target.closest ? e.target.closest('[data-nc-pill]') : null;
        if (!k) return;
        e.preventDefault();
        var wrap = k.closest('[data-nc-pills]');
        if (!wrap) return;
        var offen = k.getAttribute('aria-expanded') === 'true';

        var alle = wrap.querySelectorAll('[data-nc-pill]');
        for (var i = 0; i < alle.length; i++) alle[i].setAttribute('aria-expanded', 'false');
        var panels = wrap.querySelectorAll('[data-nc-panel]');
        for (var j = 0; j < panels.length; j++) panels[j].hidden = true;

        if (!offen) {
          k.setAttribute('aria-expanded', 'true');
          var ziel = wrap.querySelector('[data-nc-panel="' + k.getAttribute('data-nc-pill') + '"]');
          if (ziel) ziel.hidden = false;
        }
      });

      document.addEventListener('click', function (e) {
        var auf = e.target.closest ? e.target.closest('[data-nc-pmod-auf]') : null;
        if (auf) {
          var modal = document.getElementById('nc-pmod-' + auf.getAttribute('data-nc-pmod-auf'));
          if (modal && typeof modal.showModal === 'function') {
            e.preventDefault();
            modal.showModal();
          }
          return;
        }
        var zu = e.target.closest ? e.target.closest('[data-nc-pmod-zu]') : null;
        if (zu) {
          var offen = zu.closest('dialog');
          if (offen) offen.close();
        }
      });

      document.addEventListener('click', function (e) {
        if (e.target && e.target.tagName === 'DIALOG' && e.target.classList.contains('nc-pmod')) {
          e.target.close();
        }
      });

    })();
  

    (function () {
      if (window.ncVersandkostenBereit) return;
      window.ncVersandkostenBereit = true;

      var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      function sicher(text) {
        return String(text == null ? '' : text)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }

      function geld(betrag, waehrung) {
        if (betrag === null || betrag === undefined || betrag === '') return null;
        var roh = String(betrag).trim();
        var wert;
        if (/[.,]/.test(roh)) {
          wert = parseFloat(roh.replace(',', '.'));
        } else {
          wert = parseInt(roh, 10) / 100;
        }
        if (isNaN(wert)) return null;

        var w = waehrung ||
                (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'de', {
            style: 'currency', currency: w
          }).format(wert);
        } catch (e) {
          return wert.toFixed(2) + ' ' + w;
        }
      }

      function nachfassen(adresse, versuch) {
        if (versuch > 8) return null;
        return fetch(wurzel + 'cart/async_shipping_rates.json?' + adresse)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (d && d.shipping_rates && d.shipping_rates.length) return d.shipping_rates;
            return new Promise(function (loesen) {
              setTimeout(function () { loesen(nachfassen(adresse, versuch + 1)); }, 500);
            });
          })
          .catch(function () { return null; });
      }

      /* D1371: Gilt der Versand-Code des Geschenksets (data-nc-vk-code)?
         Liquid sieht ihn auf /cart nicht, /cart.js schon. */
      function freiPruefen(block) {
        var code = (block.getAttribute('data-nc-vk-code') || '').toUpperCase();
        if (!code) return Promise.resolve();
        return fetch(wurzel + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) {
            var codes = (c && c.discount_codes) || [];
            var gilt = false;
            for (var i = 0; i < codes.length; i++) {
              if (codes[i].applicable && String(codes[i].code || '').toUpperCase() === code) gilt = true;
            }
            if (gilt) block.setAttribute('data-nc-vk-frei', block.getAttribute('data-nc-vk-frei-text') || '');
            else block.removeAttribute('data-nc-vk-frei');
          })
          .catch(function () {});
      }

      function zeichnen(block, tarife) {
        freiPruefen(block).then(function () { zeichnenJetzt(block, tarife); });
      }

      function zeichnenJetzt(block, tarife) {
        var ziel = block.querySelector('[data-nc-vk-inhalt]');
        if (!ziel) return;
        var alterLink = ziel.querySelector('a');
        var linkHtml = alterLink ? alterLink.outerHTML : '';

        if (!tarife || !tarife.length) {
          ziel.innerHTML = '<p class="nc-wh__zeile">' + linkHtml + '</p>';
          return;
        }

        var titel = block.getAttribute('data-nc-vk-titel') || '';
        var teile = ['<p class="nc-vk__titel">' + titel + '</p>', '<ul class="nc-vk__liste">'];
        for (var i = 0; i < tarife.length; i++) {
          var name = tarife[i].presentment_name || tarife[i].name || '';
          var b = geld(tarife[i].price, tarife[i].currency);
          if (!b) continue;
          /* D1371: Versand-Code des Geschenksets gueltig → Preis durchgestrichen,
             „Kostenlos im Geschenkset“ (Text aus data-nc-vk-frei, gesetzt von freiPruefen). */
          var frei = block.getAttribute('data-nc-vk-frei');
          if (frei) b = '<s>' + b + '</s> ' + sicher(frei);
          teile.push('<li><span>' + sicher(name) + '</span>' +
                     '<span class="nc-vk__punkte"></span>' +
                     '<span class="nc-vk__betrag">' + b + '</span></li>');
        }
        teile.push('</ul>');
        teile.push('<p class="nc-wh__zeile nc-vk__mehr">' + linkHtml + '</p>');
        ziel.innerHTML = teile.join('');
      }

      function plzHolen() {
        try { return localStorage.getItem('nc-versand-plz') || ''; } catch (e) { return ''; }
      }
      function plzMerken(w) {
        try { localStorage.setItem('nc-versand-plz', w); } catch (e) {}
      }

      function holen(block, land, plz) {
        land = land || block.getAttribute('data-nc-vk-land') || '';
        plz = (plz === undefined) ? plzHolen() : plz;
        if (!land || !plz) return;          // ohne Angabe keine Zahl
        var stand = block.getAttribute('data-nc-vk-stand') || '';
        var schluessel = 'nc-versand-' + land + '-' + plz + '-' + stand;

        try {
          var gemerkt = sessionStorage.getItem(schluessel);
          if (gemerkt) { zeichnen(block, JSON.parse(gemerkt)); return; }
        } catch (e) {}

        var adresse = 'shipping_address[country]=' + encodeURIComponent(land) +
                      '&shipping_address[province]=&shipping_address[zip]=' + encodeURIComponent(plz);

        function fertig(tarife) {
          if (!tarife) return;
          try { sessionStorage.setItem(schluessel, JSON.stringify(tarife)); } catch (e) {}
          zeichnen(block, tarife);
        }

        fetch(wurzel + 'cart/shipping_rates.json?' + adresse)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            var t = d && d.shipping_rates;
            if (t && t.length) { fertig(t); return; }
            return fetch(wurzel + 'cart/prepare_shipping_rates.json?' + adresse, { method: 'POST' })
              .then(function (r) { return r.ok ? nachfassen(adresse, 0) : null; })
              .then(function (t2) { if (t2) fertig(t2); });
          })
          .catch(function () { /* Link bleibt stehen */ });
      }

      function suchen() {
        var bloecke = document.querySelectorAll('[data-nc-vk]:not([data-nc-vk-fertig])');
        for (var i = 0; i < bloecke.length; i++) {
          var b = bloecke[i];
          b.setAttribute('data-nc-vk-fertig', 'ja');

          var wahl = b.querySelector('[data-nc-vk-wahl]');
          if (wahl) {
            var heimat = wahl.getAttribute('data-nc-vk-heimat') || '';
            for (var j = 0; j < wahl.options.length; j++) {
              var o = wahl.options[j];
              if (o.value === heimat || o.textContent.trim() === heimat) { wahl.selectedIndex = j; break; }
            }
            b.setAttribute('data-nc-vk-land', wahl.value);
          }
          var feld = b.querySelector('[data-nc-vk-plz]');
          var gemerkt = plzHolen();
          if (feld && gemerkt) feld.value = gemerkt;
          holen(b);
        }
      }

      function rechnen(block) {
        var w = block.querySelector('[data-nc-vk-wahl]');
        var e = block.querySelector('[data-nc-vk-plz]');
        var k = block.querySelector('[data-nc-vk-los]');
        if (!w || !e) return;
        var plz = e.value.trim();
        if (!plz) { e.focus(); return; }
        plzMerken(plz);
        block.setAttribute('data-nc-vk-land', w.value);
        if (k) k.setAttribute('aria-busy', 'true');
        holen(block, w.value, plz);
        setTimeout(function () { if (k) k.removeAttribute('aria-busy'); }, 1500);
      }

      document.addEventListener('click', function (e) {
        var k = e.target.closest ? e.target.closest('[data-nc-vk-los]') : null;
        if (!k) return;
        e.preventDefault();
        rechnen(k.closest('[data-nc-vk]'));
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var f = e.target.closest ? e.target.closest('[data-nc-vk-plz]') : null;
        if (!f) return;
        e.preventDefault();
        rechnen(f.closest('[data-nc-vk]'));
      });

      document.addEventListener('change', function (e) {
        var w = e.target.closest ? e.target.closest('[data-nc-vk-wahl]') : null;
        if (!w) return;
        var block = w.closest('[data-nc-vk]');
        if (!block) return;
        block.setAttribute('data-nc-vk-land', w.value);
        if (plzHolen()) holen(block, w.value);
      });

      suchen();

      var nc_vk_ziel = document.getElementById('cart-drawer') || document.body;
      new MutationObserver(suchen).observe(nc_vk_ziel, { childList: true, subtree: true });
    })();
  

    (function () {
      if (window.ncTeilenBereit) return;
      window.ncTeilenBereit = true;

      document.addEventListener('click', function (e) {
        var k = e.target.closest ? e.target.closest('[data-nc-wt-link]') : null;
        if (!k) return;
        e.preventDefault();
        var link = k.getAttribute('data-nc-wt-link');
        var vorher = k.textContent;

        function melden() {
          k.textContent = k.getAttribute('data-nc-wt-fertig') || vorher;
          setTimeout(function () { k.textContent = vorher; }, 2500);
        }

        var titel = k.getAttribute('data-nc-wt-titel') || '';
        var text = k.getAttribute('data-nc-wt-text') || '';

        if (navigator.share) {
          navigator.share({ title: titel, text: text, url: link }).then(melden).catch(function () {});
          return;
        }
        var ablage = text ? text + '\n' + link : link;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(ablage).then(melden).catch(function () { window.prompt('', ablage); });
          return;
        }
        window.prompt('', ablage);
      });
    })();
  

  (function () {
    if (window.ncCartseiteBereit) return;
    window.ncCartseiteBereit = true;

    if (!document.querySelector('.nc-cs')) return;

    var beobachter = null;
    var gemerkt = null;

    var verbinden = function () {
      var karte = document.querySelector('.nc-cs__karte [type="submit"][name="checkout"]');
      if (karte === gemerkt) return;
      gemerkt = karte;
      if (beobachter) { beobachter.disconnect(); beobachter = null; }
      var leiste = document.querySelector('[data-nc-cs-leiste]');
      if (!leiste || !karte) return;

      beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          var vorbei = !e.isIntersecting && e.boundingClientRect.top < 0;
          if (vorbei) leiste.removeAttribute('hidden');
          else leiste.setAttribute('hidden', '');
        });
      }, { threshold: 0 });
      beobachter.observe(karte);
    };

    verbinden();
    new MutationObserver(verbinden).observe(document.body, { childList: true, subtree: true });
  })();

  (function () {
    if (window.ncKorbMerkerBereit) return;
    window.ncKorbMerkerBereit = true;

    var SCHLUESSEL = 'nc-letzter-korb';
    var HALTBAR = 30 * 24 * 60 * 60 * 1000;   /* 30 Tage */

    function lesen() {
      try {
        var roh = localStorage.getItem(SCHLUESSEL);
        if (!roh) return null;
        var d = JSON.parse(roh);
        if (!d || !d.link || !d.zeit) return null;
        if (Date.now() - d.zeit > HALTBAR) { localStorage.removeItem(SCHLUESSEL); return null; }
        return d;
      } catch (e) { return null; }
    }

    function merken() {
      var e = document.querySelector('[data-nc-wt-link]');
      if (!e) return;
      var link = e.getAttribute('data-nc-wt-link');
      if (!link || link.indexOf('/cart/') === -1) return;
      try {
        localStorage.setItem(SCHLUESSEL, JSON.stringify({ link: link, zeit: Date.now() }));
      } catch (x) {}
    }

    function zeigen() {
      var slot = document.querySelector('[data-nc-wl-zurueck]');
      if (!slot) return;
      var d = lesen();
      if (!d) { slot.setAttribute('hidden', ''); return; }
      var a = slot.querySelector('[data-nc-wl-link]');
      if (a) a.setAttribute('href', d.link);
      slot.removeAttribute('hidden');
    }

    function lauf() { merken(); zeigen(); }
    lauf();

    var ziel = document.getElementById('cart-drawer') || document.body;
    new MutationObserver(lauf).observe(ziel, { childList: true, subtree: true });
  })();

  (function () {
    if (window.ncRueckgaengigBereit) return;
    window.ncRueckgaengigBereit = true;

    var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var balken = null, uhr = null;

    function bauen() {
      if (balken) return balken;
      balken = document.createElement('div');
      balken.className = 'nc-undo';
      balken.setAttribute('role', 'status');
      document.body.appendChild(balken);
      return balken;
    }

    function verstecken() {
      if (balken) balken.removeAttribute('data-offen');
      if (uhr) clearTimeout(uhr);
    }

    function anbieten(text, knopftext, zurueck) {
      var b = bauen();
      b.innerHTML = '';
      var t = document.createElement('span');
      t.className = 'nc-undo__text';
      t.textContent = text;
      var k = document.createElement('button');
      k.type = 'button';
      k.className = 'nc-undo__knopf';
      k.textContent = knopftext;
      k.addEventListener('click', function () { verstecken(); zurueck(); });
      b.appendChild(t); b.appendChild(k);
      b.setAttribute('data-offen', 'ja');
      if (uhr) clearTimeout(uhr);
      uhr = setTimeout(verstecken, 8000);
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="/cart/change"]') : null;
      if (!a) return;
      if (!a.hasAttribute('data-nc-undo-text')) return;
      var zeile = a.closest('.line-item');
      if (!zeile) return;
      var feld = zeile.querySelector('[data-line-key]');
      var schluessel = feld ? feld.getAttribute('data-line-key') : null;
      if (!schluessel) return;
      e.stopPropagation();

      var titelEl = zeile.querySelector('.line-item-info .h6, .line-item-info a');
      var titel = titelEl ? titelEl.textContent.replace(/\s+/g, ' ').trim() : '';
      var menge = feld && feld.value ? parseInt(feld.value, 10) : 1;

      e.preventDefault();

      fetch(wurzel + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (korb) {
          var merk = null;
          if (korb && korb.items) {
            for (var i = 0; i < korb.items.length; i++) {
              if (korb.items[i].key === schluessel) { merk = korb.items[i]; break; }
            }
          }

          fetch(wurzel + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: schluessel, quantity: 0 })
          }).then(function (r) {
            if (!r.ok) { window.location.href = a.getAttribute('href'); return; }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (!merk) return;
            anbieten(
              (a.getAttribute('data-nc-undo-text') || '') + (titel ? ' ' + titel : ''),
              a.getAttribute('data-nc-undo-knopf') || 'Undo',
              function () {
                var zurueckPos = {
                  id: merk.variant_id || schluessel.split(':')[0],
                  quantity: merk.quantity || menge
                };
                if (merk.properties && Object.keys(merk.properties).length) {
                  zurueckPos.properties = merk.properties;
                }
                if (merk.selling_plan_allocation && merk.selling_plan_allocation.selling_plan) {
                  zurueckPos.selling_plan = merk.selling_plan_allocation.selling_plan.id;
                }
                fetch(wurzel + 'cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: [zurueckPos] })
                }).then(function () {
                  document.dispatchEvent(new CustomEvent('cart:refresh'));
                });
              }
            );
          }).catch(function () { window.location.href = a.getAttribute('href'); });
        });
    }, true);
  })();

  (function () {
    if (window.ncEmpZuBereit) return;
    window.ncEmpZuBereit = true;

    var SCHLUESSEL = 'nc-emp-zu';

    function zu() {
      try { return sessionStorage.getItem(SCHLUESSEL) === '1'; } catch (e) { return false; }
    }

    function anwenden() {
      if (!zu()) return;
      var alle = document.querySelectorAll('[data-nc-emp-block]');
      for (var i = 0; i < alle.length; i++) alle[i].setAttribute('hidden', '');
    }

    document.addEventListener('click', function (e) {
      var k = e.target.closest ? e.target.closest('[data-nc-emp-zu]') : null;
      if (!k) return;
      e.preventDefault();
      try { sessionStorage.setItem(SCHLUESSEL, '1'); } catch (x) {}
      anwenden();
    });

    anwenden();

    var ziel = document.getElementById('cart-drawer') || document.body;
    new MutationObserver(anwenden).observe(ziel, { childList: true, subtree: true });
  })();

  (function () {
    if (window.ncFussFaltBereit) return;
    window.ncFussFaltBereit = true;

    var FUSS = 'nc-fuss-zu';
    var EMP = 'nc-emp-mobil';

    function handy() {
      return window.matchMedia && window.matchMedia('(max-width: 699px)').matches;
    }

    function anwenden() {
      var wert = null;
      try { wert = sessionStorage.getItem(FUSS); } catch (e) {}
      if (wert === '1') {
        var falten = document.querySelectorAll('[data-nc-fuss-falt]');
        for (var i = 0; i < falten.length; i++) falten[i].removeAttribute('open');
      }
      var empAuf = null;
      try { empAuf = sessionStorage.getItem(EMP); } catch (e) {}
      if (empAuf === '0') {
        var reihen = document.querySelectorAll('.nc-empk__falt[open]');
        for (var j = 0; j < reihen.length; j++) reihen[j].removeAttribute('open');
      }
    }

    document.addEventListener('cart:change', function (e) {
      if (!e.detail || e.detail.baseEvent !== 'variant:add') return;
      try {
        sessionStorage.removeItem(FUSS);
        sessionStorage.removeItem(EMP);
      } catch (x) {}
      var auf = document.querySelectorAll('[data-nc-fuss-falt], .nc-empk__falt');
      for (var i = 0; i < auf.length; i++) auf[i].setAttribute('open', '');
    });

    document.addEventListener('toggle', function (e) {
      var el = e.target;
      if (!el || !el.hasAttribute) return;
      if (el.hasAttribute('data-nc-fuss-falt')) {
        try { sessionStorage.setItem(FUSS, el.open ? '0' : '1'); } catch (x) {}
      } else if (el.classList && el.classList.contains('nc-empk__falt') && handy()) {
        try { sessionStorage.setItem(EMP, el.open ? '1' : '0'); } catch (x) {}
      }
    }, true);

    var ziehGriff = null, ziehStartY = 0, gezogen = false;
    document.addEventListener('pointerdown', function (e) {
      var g = e.target && e.target.closest ? e.target.closest('.nc-fuss-falt__griff') : null;
      if (!g) return;
      ziehGriff = g;
      ziehStartY = e.clientY;
      gezogen = false;
    }, true);
    document.addEventListener('pointermove', function (e) {
      if (!ziehGriff) return;
      var falt = ziehGriff.closest('details');
      if (!falt) return;
      var weg = e.clientY - ziehStartY;
      if (weg > 18 && falt.open) {
        falt.removeAttribute('open');
        gezogen = true;
        ziehStartY = e.clientY;
      } else if (weg < -18 && !falt.open) {
        falt.setAttribute('open', '');
        gezogen = true;
        ziehStartY = e.clientY;
      }
    }, true);
    document.addEventListener('pointerup', function () { ziehGriff = null; }, true);
    document.addEventListener('pointercancel', function () { ziehGriff = null; }, true);
    document.addEventListener('click', function (e) {
      if (!gezogen) return;
      var g = e.target && e.target.closest ? e.target.closest('.nc-fuss-falt__griff') : null;
      if (!g) return;
      e.preventDefault();
      gezogen = false;
    }, true);

    anwenden();
    var ziel = document.getElementById('cart-drawer') || document.body;
    new MutationObserver(anwenden).observe(ziel, { childList: true, subtree: true });
  })();

  (function () {
    if (window.ncWischHinweisBereit) return;
    window.ncWischHinweisBereit = true;

    /* D1403: Im geschlossenen Seitenwarenkorb ist jede Reihe 0 px breit,
       der Pfeil bleibt dann versteckt. Oeffnet sich der Warenkorb ohne
       Neuaufbau, meldete bisher niemand die neue Breite. Der
       Groessenbeobachter prueft nach, sobald eine Reihe sichtbar wird. */
    var beobachter = window.ResizeObserver ? new ResizeObserver(function () { pruefen(); }) : null;

    var pruefen = function () {
      var baender = document.querySelectorAll('[data-nc-pills-band]');
      for (var i = 0; i < baender.length; i++) {
        var band = baender[i];
        if (beobachter && band.dataset.ncWischBeobachtet !== '1') {
          band.dataset.ncWischBeobachtet = '1';
          beobachter.observe(band);
        }
        var huelle = band.closest ? band.closest('[data-nc-pills]') : null;
        var hinweis = huelle ? huelle.querySelector('[data-nc-pills-wisch]') : null;
        if (!hinweis) continue;
        if (band.scrollWidth - band.clientWidth < 12) { hinweis.hidden = true; continue; }
        if (band.dataset.ncWischGelesen === '1') { hinweis.hidden = true; continue; }
        hinweis.hidden = false;
        if (band.dataset.ncWischGebunden === '1') continue;
        band.dataset.ncWischGebunden = '1';
        var weg = function () {
          band.dataset.ncWischGelesen = '1';
          hinweis.hidden = true;
        };
        band.addEventListener('pointerdown', weg, { once: true, passive: true });
        band.addEventListener('wheel', weg, { once: true, passive: true });
      }
    };

    /* D1403: Klick auf den Pfeil schiebt die Reihe um gut eine halbe
       Breite weiter. Am Ende verschwindet er, wie nach dem Wischen. */
    document.addEventListener('click', function (e) {
      var knopf = e.target.closest ? e.target.closest('[data-nc-pills-wisch]') : null;
      if (!knopf) return;
      var huelle = knopf.closest('[data-nc-pills]');
      var band = huelle ? huelle.querySelector('[data-nc-pills-band]') : null;
      if (!band) return;
      e.preventDefault();
      band.scrollBy({ left: Math.max(120, band.clientWidth * 0.6), behavior: 'smooth' });
      setTimeout(function () {
        if (band.scrollLeft + band.clientWidth >= band.scrollWidth - 6) {
          band.dataset.ncWischGelesen = '1';
          knopf.hidden = true;
        }
      }, 450);
    });

    pruefen();
    var ziel = document.getElementById('cart-drawer') || document.body;
    new MutationObserver(pruefen).observe(ziel, { childList: true, subtree: true });
    window.addEventListener('resize', pruefen, { passive: true });

    document.addEventListener('toggle', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-nc-fuss-falt')) {
        setTimeout(pruefen, 60);
      }
    }, true);
  })();

  (function () {
    if (window.ncPillenHinweisBereit) return;
    window.ncPillenHinweisBereit = true;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var gezeigt = false;
    var wechsel = null;

    var aufhoeren = function () {
      beobachter.disconnect();
      if (wechsel) wechsel.disconnect();
    };

    var beobachter = new IntersectionObserver(function (eintraege) {
      if (gezeigt) return;
      for (var i = 0; i < eintraege.length; i++) {
        if (!eintraege[i].isIntersecting) continue;
        var band = eintraege[i].target;
        if (band.scrollWidth - band.clientWidth < 12) continue;
        gezeigt = true;
        aufhoeren();
        setTimeout(function () {
          band.scrollTo({ left: 44, behavior: 'smooth' });
          setTimeout(function () { band.scrollTo({ left: 0, behavior: 'smooth' }); }, 600);
          setTimeout(function () { band.scrollTo({ left: 30, behavior: 'smooth' }); }, 1250);
          setTimeout(function () { band.scrollTo({ left: 0, behavior: 'smooth' }); }, 1800);
        }, 900);
        return;
      }
    }, { threshold: 0.9 });

    var anmelden = function () {
      if (gezeigt) return;
      var baender = document.querySelectorAll('[data-nc-pills-band]');
      for (var i = 0; i < baender.length; i++) beobachter.observe(baender[i]);
    };

    anmelden();
    var ziel = document.getElementById('cart-drawer') || document.body;
    wechsel = new MutationObserver(anmelden);
    wechsel.observe(ziel, { childList: true, subtree: true });
  })();

  (function () {
    if (window.ncEmpkSichtBereit) return;
    window.ncEmpkSichtBereit = true;

    document.addEventListener('toggle', function (e) {
      var falt = e.target;
      if (!falt || !falt.matches || !falt.matches('.nc-empk__falt') || !falt.open) return;
      var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      requestAnimationFrame(function () {
        falt.scrollIntoView({ block: 'nearest', behavior: ruhig ? 'auto' : 'smooth' });
      });
    }, true);
  })();

  (function () {
    if (window.ncSesselPopupBereit) return;
    window.ncSesselPopupBereit = true;

    var popup = document.querySelector('[data-nc-sp]');
    if (!popup) return;

    var karte = popup.querySelector('.nc-sp__karte');
    var bildSlot = popup.querySelector('[data-nc-sp-bild]');
    var titelSlot = popup.querySelector('[data-nc-sp-titel]');
    var vorherFokus = null;
    var treffer = null; // { item, modus }: was zuletzt einen Popup-Fall ausgeloest hat

    var gutscheinId = popup.getAttribute('data-nc-sp-gutschein-id') || '';
    var hatSesselAngebot = !!popup.querySelector('form[data-nc-sp-fuer="sessel"]');
    var hatGutscheinAngebot = !!popup.querySelector('form[data-nc-sp-fuer="gutschein"]');

    function istSessel(item) {
      if (!item || item.gift_card) return false;
      var typ = (item.product_type || '').toLowerCase();
      var titel = (item.product_title || item.title || '').toLowerCase();
      var handle = (item.handle || '').toLowerCase();
      var url = (item.url || '').toLowerCase();
      var raum = typ + ' ' + handle + ' ' + url;
      if (raum.indexOf('relax') > -1 || raum.indexOf('lounge') > -1 ||
          raum.indexOf('openspace') > -1 || raum.indexOf('gutschein') > -1 ||
          typ.indexOf('gift') > -1) {
        return false;
      }
      if (typ.indexOf('massagesessel') > -1) return true;
      if (titel.indexOf('massagesessel') > -1) return true;
      if (handle.indexOf('massagesessel') > -1) return true;
      return false;
    }

    function alsListe(items) {
      if (!items) return [];
      if (Array.isArray(items)) return items;
      if (items.items && Array.isArray(items.items)) return items.items;
      return [items];
    }

    function istGutschein(item) {
      if (!item || item.gift_card) return false;
      var t = (item.product_title || item.title || '').toLowerCase();
      var h = (item.handle || '').toLowerCase();
      if (t.indexOf('einlös') > -1 || t.indexOf('einlos') > -1 || h.indexOf('einlos') > -1) return false;
      if (gutscheinId && String(item.product_id) === String(gutscheinId)) return true;
      var istG = t.indexOf('gutschein') > -1 || h.indexOf('gutschein') > -1;
      return istG && item.requires_shipping === true;
    }

    function trefferAusListe(items) {
      var liste = alsListe(items);
      var i;
      if (hatGutscheinAngebot) {
        for (i = 0; i < liste.length; i++) {
          if (istGutschein(liste[i])) return { item: liste[i], modus: 'gutschein' };
        }
      }
      if (hatSesselAngebot) {
        for (i = 0; i < liste.length; i++) {
          if (istSessel(liste[i])) return { item: liste[i], modus: 'sessel' };
        }
      }
      return null;
    }

    function fuellen(item) {
      if (titelSlot) titelSlot.textContent = item.product_title || item.title || '';
      if (!bildSlot) return;
      bildSlot.innerHTML = '';
      var quelle = item.image || (item.featured_image && item.featured_image.url) || '';
      if (!quelle) return;
      var img = document.createElement('img');
      img.src = quelle + (quelle.indexOf('?') > -1 ? '&' : '?') + 'width=112';
      img.alt = '';
      img.loading = 'lazy';
      img.width = 56;
      img.height = 56;
      bildSlot.appendChild(img);
    }

    function stupsReihe() {
      var reihe = popup.querySelector('[data-nc-sp-reihe]');
      if (!reihe) return;
      var mehr = reihe.scrollWidth - reihe.clientWidth > 12;
      reihe.classList.toggle('nc-sp__reihe--mehr', mehr);
      if (!mehr) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      setTimeout(function () {
        reihe.scrollTo({ left: 46, behavior: 'smooth' });
        setTimeout(function () { reihe.scrollTo({ left: 0, behavior: 'smooth' }); }, 650);
      }, 480);
    }

    var infoPanel = popup.querySelector('[data-nc-sp-info]');
    function infoAuf() {
      if (!infoPanel) return;
      if (karte) karte.scrollTop = 0;
      infoPanel.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { popup.setAttribute('data-nc-sp-info-offen', 'ja'); });
      });
      var auf = popup.querySelector('[data-nc-sp-info-auf]');
      if (auf) auf.setAttribute('aria-expanded', 'true');
      var zu = infoPanel.querySelector('[data-nc-sp-info-zu]');
      if (zu) { try { zu.focus(); } catch (e) {} }
    }
    function infoZu() {
      if (!infoPanel) return;
      popup.removeAttribute('data-nc-sp-info-offen');
      var auf = popup.querySelector('[data-nc-sp-info-auf]');
      if (auf) { auf.setAttribute('aria-expanded', 'false'); try { auf.focus(); } catch (e) {} }
      var fertig = function () {
        if (!popup.hasAttribute('data-nc-sp-info-offen')) infoPanel.setAttribute('hidden', '');
        infoPanel.removeEventListener('transitionend', fertig);
      };
      infoPanel.addEventListener('transitionend', fertig);
      setTimeout(function () {
        if (!popup.hasAttribute('data-nc-sp-info-offen')) infoPanel.setAttribute('hidden', '');
      }, 400);
    }

    function oeffnen() {
      vorherFokus = document.activeElement;
      popup.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { popup.setAttribute('data-offen', 'ja'); stupsReihe(); });
      });
      document.documentElement.classList.add('nc-sp-offen');
      if (karte) { try { karte.focus(); } catch (e) {} }
      document.addEventListener('keydown', beiTaste);
    }

    function schliessen() {
      if (infoPanel && popup.hasAttribute('data-nc-sp-info-offen')) {
        popup.removeAttribute('data-nc-sp-info-offen');
        infoPanel.setAttribute('hidden', '');
        var auf0 = popup.querySelector('[data-nc-sp-info-auf]');
        if (auf0) auf0.setAttribute('aria-expanded', 'false');
      }
      popup.removeAttribute('data-offen');
      document.documentElement.classList.remove('nc-sp-offen');
      document.removeEventListener('keydown', beiTaste);
      var fertig = function () {
        if (!popup.hasAttribute('data-offen')) popup.setAttribute('hidden', '');
        popup.removeEventListener('transitionend', fertig);
      };
      popup.addEventListener('transitionend', fertig);
      setTimeout(function () {
        if (!popup.hasAttribute('data-offen')) popup.setAttribute('hidden', '');
      }, 450);
      if (vorherFokus && vorherFokus.focus) { try { vorherFokus.focus(); } catch (e) {} }
    }

    function beiTaste(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        if (popup.hasAttribute('data-nc-sp-info-offen')) { infoZu(); return; }
        schliessen();
      }
    }

    popup.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-nc-sp-info-auf]')) { infoAuf(); return; }
      if (e.target.closest('[data-nc-sp-info-zu]')) { infoZu(); return; }
      if (e.target.closest('[data-nc-sp-zu]')) schliessen();
    });

    document.addEventListener('variant:add', function (e) {
      treffer = e.detail ? trefferAusListe(e.detail.items) : null;
    });

    document.addEventListener('cart:change', function (e) {
      if (!e.detail || e.detail.baseEvent !== 'variant:add' || !treffer) return;
      var t = treffer;
      treffer = null;
      Promise.resolve().then(function () {
        var lade = document.getElementById('cart-drawer');
        if (lade && typeof lade.hide === 'function') { try { lade.hide(); } catch (err) {} }
        popup.setAttribute('data-nc-sp-modus', t.modus);
        fuellen(t.item);
        oeffnen();
      });
    });
  })();

    (function () {
      var huelle = document.querySelector('[data-nc-flex]');
      if (!huelle) return;

      function abgleichen() {
        var knopf = huelle.querySelector('.nc-fx__add');
        if (!knopf) return;

        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (korb) {
            var zeile = null;
            (korb.items || []).forEach(function (i) {
              if (i.handle === 'nc-flex-option') zeile = i;
            });

            if (zeile) {
              knopf.removeAttribute('data-nc-sa-add');
              knopf.removeAttribute('data-nc-sa-variante');
              knopf.setAttribute('data-nc-sa-weg', '');
              knopf.setAttribute('data-nc-sa-key', zeile.key);
              knopf.classList.add('nc-fx__add--weg');
              knopf.textContent = huelle.getAttribute('data-nc-fx-weg') || '';
            } else {
              knopf.removeAttribute('data-nc-sa-weg');
              knopf.removeAttribute('data-nc-sa-key');
              knopf.removeAttribute('data-nc-sa-line');
              knopf.setAttribute('data-nc-sa-add', '');
              knopf.setAttribute('data-nc-sa-variante', huelle.getAttribute('data-nc-fx-variante') || '');
              knopf.classList.remove('nc-fx__add--weg');
              knopf.textContent = huelle.getAttribute('data-nc-fx-add') || '';
            }
          })
          .catch(function () {});
      }

      document.documentElement.addEventListener('cart:refresh', abgleichen);

      window.addEventListener('pageshow', function (e) {
        if (e.persisted) abgleichen();
      });
    })();

}

